import { AlertYellowIcon } from "@/shared/icons/AlertYellowIcon";
import type { FC } from "react";
import type { ModalProps } from "antd";
import { ModalWrapper } from "../ModalWrapper";
import styles from "./styles.module.scss";

type Props = {
  message?: string;
  extraMessage?: string;
  okButtonText?: string;
  cancelButtonText?: string;
  onCancel?: () => void;
  onOk?: () => void;
} & ModalProps;

export const WarningModal: FC<Props> = ({
  cancelButtonText,
  extraMessage,
  message,
  okButtonText,
  onCancel = () => "",
  onOk = () => "",
  ...props
}) => {
  const classNames = {
    wrapper: styles["modal-wrapper"],
    mask: styles["modal-mask"],
    body: styles["modal-body"],
    content: styles["modal-content"],
    footer: styles["modal-footer"],
  };
  return (
    <ModalWrapper
      type="save"
      okText={okButtonText}
      cancelText={cancelButtonText}
      modalTitle={""}
      onOk={onOk}
      onCancel={onCancel}
      className={styles.root}
      classNames={classNames}
      width={400}
      {...props}
    >
      <AlertYellowIcon width={24} height={24} />
      <p className={styles["header-text"]}>{message}</p>
      <p className={styles["sub-header-text"]}>{extraMessage}</p>
    </ModalWrapper>
  );
};
